// Scroll Reveal con Intersection Observer
document.addEventListener('DOMContentLoaded', function() {
  const revealElements = document.querySelectorAll('[data-scroll-reveal]');
  
  const observerOptions = {
    threshold: 0.2,  // Parte quando il 20% è visibile
    rootMargin: '0px 0px 0px 0px'  // Nessun margine extra
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  revealElements.forEach(el => observer.observe(el));
});
